import { IDeviceBrand, IDeviceBrandGeneration, ILastGeneration, IModelGeneration } from '@/types/resource.types';
import { searchStringArray } from './array.utils';

export function searchDeviceList(keyword: string, list: IDeviceBrand[]): IDeviceBrand[] {
    if(!keyword) return list;
    let q = keyword.toLowerCase();
    return list.filter(m => (m.brandName + ' ' + m.modelName).toLowerCase().indexOf(q) > -1);
}
export function searchGenerationList(keyword: string, list: ILastGeneration[]): ILastGeneration[] {
    if(!keyword) return list;
    let q = keyword.toLowerCase();
    return list.filter(m => (m.name).toLowerCase().indexOf(q) > -1);
}
export function searchDeviceGenList(keyword: string, list: IDeviceBrandGeneration[]): IDeviceBrandGeneration[] {
    if(!keyword) return list;
    let brands: IDeviceBrandGeneration[] = [];
    let q = keyword.toLowerCase();
    list.forEach(brand => {
        let modelGenerations : IModelGeneration[] = [];
        for(let i = 0; i < brand.modelGenerations.length; i++){
            let thisModelGen = brand.modelGenerations[i];
            if(brand.brandName.toLowerCase().indexOf(q) > -1 || thisModelGen.modelName.toLowerCase().indexOf(q) > -1){
                modelGenerations.push(thisModelGen);
                continue;
            }
            let matches = thisModelGen.generations.filter(m => m.toLowerCase().indexOf(q) > -1);
            if(matches.length)  {
                modelGenerations.push(
                    {
                        modelName: thisModelGen.modelName,
                        generations: matches
                    }
                );
            }   
        }
        if(modelGenerations.length > 0){
            brands.push({
                brandName: brand.brandName,
                modelGenerations: modelGenerations
            });
        }
    });
    return brands;
}